import {createContext} from "react";

export const UnauthorizedContext = createContext(null);
